import '../sass/app.scss';
import "@babel/polyfill";
import { VueModule } from './modules/vue';
import { I18nModule } from './modules/i18n';
import { emojiListNameIndex } from '../plugins/quill-emoji/src/emoji-list';
import emojiData from 'emoji-mart-vue/data/twitter.json';

// Charger les fichiers javascripts globaux.
require('./bootstrap');

require('./websocket');

require('./dynamiclinks');

I18nModule.init();

VueModule.init();

WS.join(`tasks.peruser.${window.user_id}`, async (data) => {
  if(data.action !== undefined && window.user_id == data.user_id){
    let unread_count = data.unread_count ?? 0;
    switch(data.action){
      case "update":
        if(unread_count == 0){
          $(".unread-tasks-count").hide();
          $(".unread-tasks-count").text("")
        } else {
          $(".unread-tasks-count").show();
          $(".unread-tasks-count").text(`${unread_count}`)
          document.querySelector("#notification-task-update-audio").play();
        }
        break;
      case "markread":
        if(unread_count == 0){
          $(".unread-tasks-count").hide();
          $(".unread-tasks-count").text("")
        } else {
          $(".unread-tasks-count").show();
          $(".unread-tasks-count").text(`${unread_count}`)
        }
        break;
    }
    App.updateUnreadNotificationsIndicatorToTitle();
  }
})

WS.join("task-reminder", async (data) => {

  switch(data.action){
    case "reminder-read":
      if(parseInt(window.user_id) == parseInt(data.user_id)){
        let unread = $(".bell-notification-counter").data("count")-1;
        $(".bell-notification-counter").data("count", unread)
        $(".bell-notification-counter").text(unread);

        if(unread <= 0){
          $(".bell-notification-counter").addClass("hidden");
        } else {
          $(".bell-notification-counter").removeClass("hidden");
        }
        App.updateUnreadNotificationsIndicatorToTitle();
      }
      break;
  }

});

WS.join(`chatrooms.peruser.${window.user_id}`, (data) => {

  switch(data.action){
    case "update-unread-count":
      if(parseInt(window.user_id) == parseInt(data.user_id)){
        let unread = data.count;
        $(".chatroom-notification-counter").data("count", unread)
        $(".chatroom-notification-counter").text(unread);

        if(unread <= 0){
          $(".chatroom-notification-counter").addClass("hidden");
        } else {
          $(".chatroom-notification-counter").removeClass("hidden");
        }
        App.updateUnreadNotificationsIndicatorToTitle();
      }
      break;
  }

});

  
WS.join(`chatrooms.peruser.${window.user_id}`, (data) => {
  if(data.action != null){
    switch(data.action) {
      case "new-message":
        console.log(data);
        if(data.participant.user_id != window.user_id){
          $("#notification-chat-audio")[0].play();
        }
        break;
    }
  }
});

Object.serialize = function (obj) {
  return Object.keys(obj).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(obj[k] ?? "")).join('&');
};

window.advancedFormat = (text) => {
  text = text.replaceAll(/\n/g, "<br>")
  text = text.replace(/(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim, '<a href="$1" target="_blank">$1</a>')
  text = text.replace(/(\b([a-zA-Z0-9\-\_\.])+@[a-zA-Z0-9\_]+?(\.[a-zA-Z]{2,6})+)/gim, '<a href="mailto:$1">$1</a>')

  text = text.replace(/<project\:([0-9]+)>/gim, `<a href="${window.baseUrl}project/view/$1" target="_blank" data-project-id="$1" class="label-dynamic label-link label-project">$1</a>`);
  text = text.replace(/<task\:([0-9]+)>/gim, `<a href="${window.baseUrl}dashboard?task=$1&popup=0" target="_blank" data-task-id="$1" class="label-dynamic label-link label-task">$1</a>`);
  text = text.replace(/<user\:([0-9]+)>/gim, `<a href="javascript:;" data-user-id="$1" class="label-dynamic label-link label-user">$1</a>`);

  let SHEET_COLUMNS = 52;
    
  let multiply = 100 / (SHEET_COLUMNS - 1);

  let emojiMatcher = text.matchAll(/<emoji\:([0-9a-zA-Z_\+\-]+)>/gim);
  for (const match of emojiMatcher) {
    if(match[1] !== undefined){
      let emoji = emojiData.emojis[match[1]];
      console.log(emoji);
      if(emoji != null){
        let x = multiply * emoji.k[0],
            y = multiply * emoji.k[1],
            bg = "https://unpkg.com/emoji-datasource-twitter@4.0.4/img/twitter/sheets-256/16.png";

        text = text.replace(match[0],`<span class="span-emote" title="${emoji.a}" style="background-image: url(${bg}); background-position: ${x}% ${y}%"></span>`)
      }
    }
  }

  //emojiListNameIndex

  return text;
}

function getCaretPosition (node) {
  var range = window.getSelection().getRangeAt(0),
      preCaretRange = range.cloneRange(),
      caretPosition,
      tmp = document.createElement("div");

  preCaretRange.selectNodeContents(node);
  preCaretRange.setEnd(range.endContainer, range.endOffset);
  tmp.appendChild(preCaretRange.cloneContents());
  caretPosition = tmp.innerHTML.length;
  return caretPosition;
}

window.getCaretPositionHTML = (element) => {
  var textPosition = getCaretPosition(element);
  return textPosition;
}

App.updateUnreadNotificationsIndicatorToTitle = () => {
  let title = App.titleText;
  let unreadTaskCount = parseInt(document.getElementsByClassName("unread-tasks-count")[0].innerHTML)
  let unreadChatCount = parseInt(document.getElementsByClassName("chatroom-notification-counter")[0].innerHTML)
  let totalCount = unreadChatCount + unreadTaskCount;
  if(totalCount > 0){
    title = `(${totalCount}) ${title}`;
  }

  if(document.querySelector("title").innerHTML != title){
    document.querySelector("title").innerHTML = title;
  }
}

App.titleText = "Liste des tâches | Strana";

setTimeout(() => {
  App.updateUnreadNotificationsIndicatorToTitle();
}, 750);